import { addFiles, editFiles, filesInfo } from './request';
import { TYPE } from './utils';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      TYPE,
      unitList: [],
      quillOption: quillConfig,
      dataFrom: {
        type: undefined,
        unitId: undefined,
        remark: '',
        name: '',
        content: ''
      },
      dialogVisible: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('文件名称'),
          trigger: 'blur'
        }, {
          max: 30,
          message: this.$t('最多输入30字符'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('变量类型'),
          trigger: 'change'
        }],
        unitId: [{
          required: true,
          message: this.$t('请选择') + this.$t('承保单位'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('文本内容')
        }],
        remark: [{
          required: false,
          max: 30,
          message: this.$t('最多输入30字符'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    filterOption(input, option) {
      console.log(option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async init(val, unitList) {
      if (val) {
        this.dataFrom = await filesInfo({
          documentId: val.id
        });
      }
      this.unitList = unitList;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.documentId ? editFiles : addFiles;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};